import type { SceneConfig } from '@/types/weather';

interface Props {
  config: SceneConfig;
  lightning: boolean;
  lightningFrequency: SceneConfig['lightningFrequency'];
}

export function SkyLayer({ config, lightning, lightningFrequency }: Props) {
  const { top } = config.skyGradient;
  const duration = lightningFrequency === 'frequent' ? '3s' : '5s';

  return (
    <div
      className="layer"
      style={{
        background: top,
        transition: 'background 4s ease-in-out',
        zIndex: 0,
      }}
    >
      {lightning && (
        <div
          style={{
            position: 'absolute',
            inset: 0,
            background: 'rgba(255, 255, 255, 1)',
            animationName: 'skyFlash',
            animationDuration: duration,
            animationTimingFunction: 'linear',
            animationIterationCount: 'infinite',
          }}
        />
      )}
    </div>
  );
}
